import { 
  Home,
  Briefcase,
  Target,
  BookOpen,
  Activity,
  Palette,
  Wrench,
  Gamepad2,
  Smartphone,
  Star,
  Rocket,
  Lightbulb,
  Users,
  ShoppingCart,
  Heart,
  Code,
  Coffee,
  Music,
  Folder,
  type LucideIcon
} from 'lucide-react';

// Map of icon names to Lucide components
export const contextIcons: Record<string, LucideIcon> = {
  'folder': Folder,
  'home': Home,
  'briefcase': Briefcase,
  'target': Target,
  'book-open': BookOpen,
  'activity': Activity,
  'palette': Palette,
  'wrench': Wrench,
  'gamepad': Gamepad2,
  'smartphone': Smartphone,
  'star': Star,
  'rocket': Rocket,
  'lightbulb': Lightbulb,
  'users': Users,
  'shopping-cart': ShoppingCart,
  'heart': Heart,
  'code': Code,
  'coffee': Coffee,
  'music': Music,
};

// Array of available icon options for selection
export const contextIconOptions = Object.keys(contextIcons);

// Default icon
export const defaultContextIcon = 'folder';